import type { Permission } from "@/lib/permissions";
import { useUserStore } from "@/store/userStore";

export function useUser() {
  return useUserStore((s) => s.user);
}

export function useHasPermission(permission: Permission): boolean {
  return useUserStore((s) => s.permissions.includes(permission));
}

export function useHasAnyPermission(permissions: Permission[]): boolean {
  return useUserStore((s) => permissions.some((p) => s.permissions.includes(p)));
}

export function useHasAllPermissions(permissions: Permission[]): boolean {
  return useUserStore((s) => permissions.every((p) => s.permissions.includes(p)));
}
